import { gql } from "@apollo/client";

export const SIGN_IN_MUTATION = gql`
  mutation signIn(
    $email: String!
    $password: String!
    $mfaRememberToken: String
  ) {
    signIn(
      email: $email
      password: $password
      mfaRememberToken: $mfaRememberToken
    ) {
      token
      mfaRequired
      mfaSession
      mfaRememberToken
      user {
        mfaEnabled
        createdAt
        email
        firstName
        id
        lastName
        name
        updatedAt
        role {
          id
          name
        }
      }
    }
  }
`;

export const SIGN_UP_MUTATION = gql`
  mutation signUp($userArgs: CreateUserInputType!) {
    signUp(userArgs: $userArgs) {
      success
      errors {
        details
        fullMessages
      }
    }
  }
`;

export const REQUEST_ACCESS_MUTATION = gql`
  mutation RequestAccess(
    $email: String!
    $name: String
    $planCode: String
    $source: String
  ) {
    requestAccess(
      email: $email
      name: $name
      planCode: $planCode
      source: $source
    ) {
      success
      errors
    }
  }
`;

export const UPDATE_USER_MUTATION = gql`
  mutation updateUser($fieldName: String!, $fieldValue: String!) {
    updateUser(user: { fieldName: $fieldName, fieldValue: $fieldValue }) {
      avatar
      createdAt
      email
      firstName
      id
      lastName
      name
      updatedAt
    }
  }
`;

export const COMPLETE_ONBOARDING_MUTATION = gql`
  mutation CompleteOnboarding {
    completeOnboarding {
      id
      onboarded
    }
  }
`;

export const CREATE_ORGANISATION_MUTATION = gql`
  mutation CreateOrganisation($organisation: CreateOrganisationInputType!) {
    createOrganisation(organisation: $organisation) {
      id
      organisation {
        id
        name
      }
      role {
        id
        name
      }
      createdAt
    }
  }
`;

export const UPDATE_ORGANISATION_MUTATION = gql`
  mutation UpdateOrganisation(
    $id: ID!
    $organisation: UpdateOrganisationInputType!
  ) {
    updateOrganisation(id: $id, organisation: $organisation) {
      id
      name
    }
  }
`;

export const LEAVE_ORGANISATION_MUTATION = gql`
  mutation LeaveOrganisation($membershipId: ID!) {
    leaveOrganisation(membershipId: $membershipId) {
      success
      membership {
        id
      }
    }
  }
`;

export const UPDATE_CURRENT_USER_PASSWORD_MUTATION = gql`
  mutation updateCurrentUserPassword($input: UpdatePasswordInput!) {
    updateCurrentUserPassword(input: $input) {
      id
      email
      name
    }
  }
`;

export const INVITE_TEAM_MEMBER_MUTATION = gql`
  mutation InviteTeamMember($email: String!) {
    inviteTeamMember(email: $email) {
      success
      message
    }
  }
`;

export const SET_CURRENT_ORGANISATION_MUTATION = gql`
  mutation SetCurrentOrganisation($organisationId: ID!) {
    setCurrentOrganisation(organisationId: $organisationId) {
      id
      name
    }
  }
`;

export const ASSIGN_ROLE_MUTATION = gql`
  mutation AssignRole($membershipId: ID!, $roleId: ID!) {
    assignRole(membershipId: $membershipId, roleId: $roleId) {
      success
      membership {
        id
        role {
          id
          name
        }
      }
      errors {
        fullMessages
      }
    }
  }
`;

export const REMOVE_MEMBER_MUTATION = gql`
  mutation RemoveMember($membershipId: ID!, $userId: ID!) {
    removeMember(membershipId: $membershipId, userId: $userId) {
      success
      membership {
        id
      }
      user {
        id
      }
    }
  }
`;

export const ENABLE_MFA_MUTATION = gql`
  mutation EnableMfa {
    enableMfa {
      user {
        mfaEnabled
        mfaBackupCodeCount
        mfaTotpUri
        mfaTotpSecret
      }
      mfaBackupCodes
    }
  }
`;

export const DISABLE_MFA_MUTATION = gql`
  mutation DisableMfa {
    disableMfa {
      mfaEnabled
      mfaBackupCodeCount
    }
  }
`;

export const REGENERATE_MFA_BACKUP_CODES_MUTATION = gql`
  mutation RegenerateMfaBackupCodes {
    regenerateMfaBackupCodes {
      user {
        mfaBackupCodeCount
      }
      mfaBackupCodes
    }
  }
`;

export const CONSUME_MFA_BACKUP_CODE_MUTATION = gql`
  mutation ConsumeMfaBackupCode(
    $mfaSession: String!
    $code: String!
    $rememberDevice: Boolean
  ) {
    consumeMfaBackupCode(
      mfaSession: $mfaSession
      code: $code
      rememberDevice: $rememberDevice
    ) {
      token
      user {
        id
        email
        name
      }
      success
      mfaRequired
      mfaSession
      mfaRememberToken
    }
  }
`;

export const VERIFY_MFA_CODE_MUTATION = gql`
  mutation verifyMfaCode(
    $mfaSession: String!
    $code: String!
    $rememberDevice: Boolean
  ) {
    verifyMfaCode(
      mfaSession: $mfaSession
      code: $code
      rememberDevice: $rememberDevice
    ) {
      token
      mfaRememberToken
      mfaRequired
      mfaSession
      user {
        createdAt
        email
        firstName
        id
        lastName
        name
        updatedAt
        role {
          id
          name
        }
      }
    }
  }
`;
